module.exports = __webpack_public_path__ + "static/media/1017086.df97fa57.png";